package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets18 {
  internal val _8_shemuel_a_22_txt: AssetResource by lazy { init__8_shemuel_a_22_txt() }

  internal val _8_shemuel_a_23_txt: AssetResource by lazy { init__8_shemuel_a_23_txt() }

  internal val _8_shemuel_a_24_txt: AssetResource by lazy { init__8_shemuel_a_24_txt() }

  internal val _8_shemuel_a_25_txt: AssetResource by lazy { init__8_shemuel_a_25_txt() }

  internal val _8_shemuel_a_26_txt: AssetResource by lazy { init__8_shemuel_a_26_txt() }

  internal val _8_shemuel_a_27_txt: AssetResource by lazy { init__8_shemuel_a_27_txt() }

  internal val _8_shemuel_a_28_txt: AssetResource by lazy { init__8_shemuel_a_28_txt() }

  internal val _8_shemuel_a_29_txt: AssetResource by lazy { init__8_shemuel_a_29_txt() }

  internal val _8_shemuel_a_30_txt: AssetResource by lazy { init__8_shemuel_a_30_txt() }

  internal val _8_shemuel_a_31_txt: AssetResource by lazy { init__8_shemuel_a_31_txt() }

  internal val _9_shemuel_b_01_txt: AssetResource by lazy { init__9_shemuel_b_01_txt() }

  internal val _9_shemuel_b_02_txt: AssetResource by lazy { init__9_shemuel_b_02_txt() }

  internal val _9_shemuel_b_03_txt: AssetResource by lazy { init__9_shemuel_b_03_txt() }

  internal val _9_shemuel_b_04_txt: AssetResource by lazy { init__9_shemuel_b_04_txt() }

  internal val _9_shemuel_b_05_txt: AssetResource by lazy { init__9_shemuel_b_05_txt() }

  internal val _9_shemuel_b_06_txt: AssetResource by lazy { init__9_shemuel_b_06_txt() }

  internal val _9_shemuel_b_07_txt: AssetResource by lazy { init__9_shemuel_b_07_txt() }

  internal val _9_shemuel_b_08_txt: AssetResource by lazy { init__9_shemuel_b_08_txt() }

  internal val _9_shemuel_b_09_txt: AssetResource by lazy { init__9_shemuel_b_09_txt() }

  internal val _9_shemuel_b_10_txt: AssetResource by lazy { init__9_shemuel_b_10_txt() }

  internal val _9_shemuel_b_11_txt: AssetResource by lazy { init__9_shemuel_b_11_txt() }

  internal val _9_shemuel_b_12_txt: AssetResource by lazy { init__9_shemuel_b_12_txt() }

  internal val _9_shemuel_b_13_txt: AssetResource by lazy { init__9_shemuel_b_13_txt() }

  internal val _9_shemuel_b_14_txt: AssetResource by lazy { init__9_shemuel_b_14_txt() }

  internal val _9_shemuel_b_15_txt: AssetResource by lazy { init__9_shemuel_b_15_txt() }

  internal val _9_shemuel_b_16_txt: AssetResource by lazy { init__9_shemuel_b_16_txt() }

  internal val _9_shemuel_b_17_txt: AssetResource by lazy { init__9_shemuel_b_17_txt() }

  internal val _9_shemuel_b_18_txt: AssetResource by lazy { init__9_shemuel_b_18_txt() }

  internal val _9_shemuel_b_19_txt: AssetResource by lazy { init__9_shemuel_b_19_txt() }

  internal val _9_shemuel_b_20_txt: AssetResource by lazy { init__9_shemuel_b_20_txt() }

  internal val _9_shemuel_b_21_txt: AssetResource by lazy { init__9_shemuel_b_21_txt() }

  internal val _9_shemuel_b_22_txt: AssetResource by lazy { init__9_shemuel_b_22_txt() }

  internal val _9_shemuel_b_23_txt: AssetResource by lazy { init__9_shemuel_b_23_txt() }

  internal val _9_shemuel_b_24_txt: AssetResource by lazy { init__9_shemuel_b_24_txt() }

  internal val bible_search_json: AssetResource by lazy { init_bible_search_json() }

  internal val Keter_Medium_ttf: AssetResource by lazy { init_Keter_Medium_ttf() }

  internal val READ_ME_txt: AssetResource by lazy { init_READ_ME_txt() }

  internal val adults_international_txt: AssetResource by lazy { init_adults_international_txt() }

  internal val adults_national_txt: AssetResource by lazy { init_adults_national_txt() }

  internal val introduction_adults_txt: AssetResource by lazy { init_introduction_adults_txt() }

  internal val full_mikud_list_txt: AssetResource by lazy { init_full_mikud_list_txt() }

  internal val mikud_menu_txt: AssetResource by lazy { init_mikud_menu_txt() }

  internal val introduction_youth_txt: AssetResource by lazy { init_introduction_youth_txt() }

  internal val youth_religious_txt: AssetResource by lazy { init_youth_religious_txt() }

  internal val youth_state_txt: AssetResource by lazy { init_youth_state_txt() }

  internal val _1_bereshit_onqelos_txt: AssetResource by lazy { init__1_bereshit_onqelos_txt() }

  internal val _2_shemot_onqelos_txt: AssetResource by lazy { init__2_shemot_onqelos_txt() }

  internal val _3_vayikra_onqelos_txt: AssetResource by lazy { init__3_vayikra_onqelos_txt() }

  internal val _4_bamidbar_onqelos_txt: AssetResource by lazy { init__4_bamidbar_onqelos_txt() }

  internal val _5_devarim_onqelos_txt: AssetResource by lazy { init__5_devarim_onqelos_txt() }

  internal fun values(): List<AssetResource> = listOf(_8_shemuel_a_22_txt, _8_shemuel_a_23_txt,
      _8_shemuel_a_24_txt, _8_shemuel_a_25_txt, _8_shemuel_a_26_txt, _8_shemuel_a_27_txt,
      _8_shemuel_a_28_txt, _8_shemuel_a_29_txt, _8_shemuel_a_30_txt, _8_shemuel_a_31_txt,
      _9_shemuel_b_01_txt, _9_shemuel_b_02_txt, _9_shemuel_b_03_txt, _9_shemuel_b_04_txt,
      _9_shemuel_b_05_txt, _9_shemuel_b_06_txt, _9_shemuel_b_07_txt, _9_shemuel_b_08_txt,
      _9_shemuel_b_09_txt, _9_shemuel_b_10_txt, _9_shemuel_b_11_txt, _9_shemuel_b_12_txt,
      _9_shemuel_b_13_txt, _9_shemuel_b_14_txt, _9_shemuel_b_15_txt, _9_shemuel_b_16_txt,
      _9_shemuel_b_17_txt, _9_shemuel_b_18_txt, _9_shemuel_b_19_txt, _9_shemuel_b_20_txt,
      _9_shemuel_b_21_txt, _9_shemuel_b_22_txt, _9_shemuel_b_23_txt, _9_shemuel_b_24_txt,
      bible_search_json, Keter_Medium_ttf, READ_ME_txt, adults_international_txt,
      adults_national_txt, introduction_adults_txt, full_mikud_list_txt, mikud_menu_txt,
      introduction_youth_txt, youth_religious_txt, youth_state_txt, _1_bereshit_onqelos_txt,
      _2_shemot_onqelos_txt, _3_vayikra_onqelos_txt, _4_bamidbar_onqelos_txt,
      _5_devarim_onqelos_txt)
}

private fun init__8_shemuel_a_22_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-22.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-22.txt")

private fun init__8_shemuel_a_23_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-23.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-23.txt")

private fun init__8_shemuel_a_24_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-24.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-24.txt")

private fun init__8_shemuel_a_25_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-25.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-25.txt")

private fun init__8_shemuel_a_26_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-26.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-26.txt")

private fun init__8_shemuel_a_27_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-27.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-27.txt")

private fun init__8_shemuel_a_28_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-28.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-28.txt")

private fun init__8_shemuel_a_29_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-29.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-29.txt")

private fun init__8_shemuel_a_30_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-30.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-30.txt")

private fun init__8_shemuel_a_31_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_8_shemuel_a-31.txt\")") as String, rawPath =
    "allChapters/_8_shemuel_a-31.txt")

private fun init__9_shemuel_b_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_9_shemuel_b-01.txt\")") as String, rawPath =
    "allChapters/_9_shemuel_b-01.txt")

private fun init__9_shemuel_b_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_9_shemuel_b-02.txt\")") as String, rawPath =
    "allChapters/_9_shemuel_b-02.txt")

private fun init__9_shemuel_b_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_9_shemuel_b-03.txt\")") as String, rawPath =
    "allChapters/_9_shemuel_b-03.txt")

private fun init__9_shemuel_b_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_9_shemuel_b-04.txt\")") as String, rawPath =
    "allChapters/_9_shemuel_b-04.txt")

private fun init__9_shemuel_b_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_9_shemuel_b-05.txt\")") as String, rawPath =
    "allChapters/_9_shemuel_b-05.txt")

private fun init__9_shemuel_b_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_9_shemuel_b-06.txt\")") as String, rawPath =
    "allChapters/_9_shemuel_b-06.txt")

private fun init__9_shemuel_b_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_9_shemuel_b-07.txt\")") as String, rawPath =
    "allChapters/_9_shemuel_b-07.txt")

private fun init__9_shemuel_b_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_9_shemuel_b-08.txt\")") as String, rawPath =
    "allChapters/_9_shemuel_b-08.txt")

private fun init__9_shemuel_b_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_9_shemuel_b-09.txt\")") as String, rawPath =
    "allChapters/_9_shemuel_b-09.txt")

private fun init__9_shemuel_b_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_9_shemuel_b-10.txt\")") as String, rawPath =
    "allChapters/_9_shemuel_b-10.txt")

private fun init__9_shemuel_b_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_9_shemuel_b-11.txt\")") as String, rawPath =
    "allChapters/_9_shemuel_b-11.txt")

private fun init__9_shemuel_b_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_9_shemuel_b-12.txt\")") as String, rawPath =
    "allChapters/_9_shemuel_b-12.txt")

private fun init__9_shemuel_b_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_9_shemuel_b-13.txt\")") as String, rawPath =
    "allChapters/_9_shemuel_b-13.txt")

private fun init__9_shemuel_b_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_9_shemuel_b-14.txt\")") as String, rawPath =
    "allChapters/_9_shemuel_b-14.txt")

private fun init__9_shemuel_b_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_9_shemuel_b-15.txt\")") as String, rawPath =
    "allChapters/_9_shemuel_b-15.txt")

private fun init__9_shemuel_b_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_9_shemuel_b-16.txt\")") as String, rawPath =
    "allChapters/_9_shemuel_b-16.txt")

private fun init__9_shemuel_b_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_9_shemuel_b-17.txt\")") as String, rawPath =
    "allChapters/_9_shemuel_b-17.txt")

private fun init__9_shemuel_b_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_9_shemuel_b-18.txt\")") as String, rawPath =
    "allChapters/_9_shemuel_b-18.txt")

private fun init__9_shemuel_b_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_9_shemuel_b-19.txt\")") as String, rawPath =
    "allChapters/_9_shemuel_b-19.txt")

private fun init__9_shemuel_b_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_9_shemuel_b-20.txt\")") as String, rawPath =
    "allChapters/_9_shemuel_b-20.txt")

private fun init__9_shemuel_b_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_9_shemuel_b-21.txt\")") as String, rawPath =
    "allChapters/_9_shemuel_b-21.txt")

private fun init__9_shemuel_b_22_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_9_shemuel_b-22.txt\")") as String, rawPath =
    "allChapters/_9_shemuel_b-22.txt")

private fun init__9_shemuel_b_23_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_9_shemuel_b-23.txt\")") as String, rawPath =
    "allChapters/_9_shemuel_b-23.txt")

private fun init__9_shemuel_b_24_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_9_shemuel_b-24.txt\")") as String, rawPath =
    "allChapters/_9_shemuel_b-24.txt")

private fun init_bible_search_json(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/animations/bible_search.json\")") as String, rawPath =
    "animations/bible_search.json")

private fun init_Keter_Medium_ttf(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/fonts/Keter-Medium.ttf\")") as String, rawPath =
    "fonts/Keter-Medium.ttf")

private fun init_READ_ME_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/mikudLevels/READ_ME.txt\")") as String, rawPath =
    "mikudLevels/READ_ME.txt")

private fun init_adults_international_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/mikudLevels/adults/adults_international.txt\")") as String, rawPath =
    "mikudLevels/adults/adults_international.txt")

private fun init_adults_national_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/mikudLevels/adults/adults_national.txt\")") as String, rawPath =
    "mikudLevels/adults/adults_national.txt")

private fun init_introduction_adults_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/mikudLevels/adults/introduction_adults.txt\")") as String, rawPath =
    "mikudLevels/adults/introduction_adults.txt")

private fun init_full_mikud_list_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/mikudLevels/full_mikud_list.txt\")") as String, rawPath =
    "mikudLevels/full_mikud_list.txt")

private fun init_mikud_menu_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/mikudLevels/mikud_menu.txt\")") as String, rawPath =
    "mikudLevels/mikud_menu.txt")

private fun init_introduction_youth_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/mikudLevels/youth/introduction_youth.txt\")") as String, rawPath =
    "mikudLevels/youth/introduction_youth.txt")

private fun init_youth_religious_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/mikudLevels/youth/youth_religious.txt\")") as String, rawPath =
    "mikudLevels/youth/youth_religious.txt")

private fun init_youth_state_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/mikudLevels/youth/youth_state.txt\")") as String, rawPath =
    "mikudLevels/youth/youth_state.txt")

private fun init__1_bereshit_onqelos_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/onqelos/_1_bereshit_onqelos.txt\")") as String, rawPath =
    "onqelos/_1_bereshit_onqelos.txt")

private fun init__2_shemot_onqelos_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/onqelos/_2_shemot_onqelos.txt\")") as String, rawPath =
    "onqelos/_2_shemot_onqelos.txt")

private fun init__3_vayikra_onqelos_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/onqelos/_3_vayikra_onqelos.txt\")") as String, rawPath =
    "onqelos/_3_vayikra_onqelos.txt")

private fun init__4_bamidbar_onqelos_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/onqelos/_4_bamidbar_onqelos.txt\")") as String, rawPath =
    "onqelos/_4_bamidbar_onqelos.txt")

private fun init__5_devarim_onqelos_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/onqelos/_5_devarim_onqelos.txt\")") as String, rawPath =
    "onqelos/_5_devarim_onqelos.txt")

public actual val SharedRes.assets.allChapters._8_shemuel_a_22_txt: AssetResource
  get() = CommonMainAssets18._8_shemuel_a_22_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_23_txt: AssetResource
  get() = CommonMainAssets18._8_shemuel_a_23_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_24_txt: AssetResource
  get() = CommonMainAssets18._8_shemuel_a_24_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_25_txt: AssetResource
  get() = CommonMainAssets18._8_shemuel_a_25_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_26_txt: AssetResource
  get() = CommonMainAssets18._8_shemuel_a_26_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_27_txt: AssetResource
  get() = CommonMainAssets18._8_shemuel_a_27_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_28_txt: AssetResource
  get() = CommonMainAssets18._8_shemuel_a_28_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_29_txt: AssetResource
  get() = CommonMainAssets18._8_shemuel_a_29_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_30_txt: AssetResource
  get() = CommonMainAssets18._8_shemuel_a_30_txt

public actual val SharedRes.assets.allChapters._8_shemuel_a_31_txt: AssetResource
  get() = CommonMainAssets18._8_shemuel_a_31_txt

public actual val SharedRes.assets.allChapters._9_shemuel_b_01_txt: AssetResource
  get() = CommonMainAssets18._9_shemuel_b_01_txt

public actual val SharedRes.assets.allChapters._9_shemuel_b_02_txt: AssetResource
  get() = CommonMainAssets18._9_shemuel_b_02_txt

public actual val SharedRes.assets.allChapters._9_shemuel_b_03_txt: AssetResource
  get() = CommonMainAssets18._9_shemuel_b_03_txt

public actual val SharedRes.assets.allChapters._9_shemuel_b_04_txt: AssetResource
  get() = CommonMainAssets18._9_shemuel_b_04_txt

public actual val SharedRes.assets.allChapters._9_shemuel_b_05_txt: AssetResource
  get() = CommonMainAssets18._9_shemuel_b_05_txt

public actual val SharedRes.assets.allChapters._9_shemuel_b_06_txt: AssetResource
  get() = CommonMainAssets18._9_shemuel_b_06_txt

public actual val SharedRes.assets.allChapters._9_shemuel_b_07_txt: AssetResource
  get() = CommonMainAssets18._9_shemuel_b_07_txt

public actual val SharedRes.assets.allChapters._9_shemuel_b_08_txt: AssetResource
  get() = CommonMainAssets18._9_shemuel_b_08_txt

public actual val SharedRes.assets.allChapters._9_shemuel_b_09_txt: AssetResource
  get() = CommonMainAssets18._9_shemuel_b_09_txt

public actual val SharedRes.assets.allChapters._9_shemuel_b_10_txt: AssetResource
  get() = CommonMainAssets18._9_shemuel_b_10_txt

public actual val SharedRes.assets.allChapters._9_shemuel_b_11_txt: AssetResource
  get() = CommonMainAssets18._9_shemuel_b_11_txt

public actual val SharedRes.assets.allChapters._9_shemuel_b_12_txt: AssetResource
  get() = CommonMainAssets18._9_shemuel_b_12_txt

public actual val SharedRes.assets.allChapters._9_shemuel_b_13_txt: AssetResource
  get() = CommonMainAssets18._9_shemuel_b_13_txt

public actual val SharedRes.assets.allChapters._9_shemuel_b_14_txt: AssetResource
  get() = CommonMainAssets18._9_shemuel_b_14_txt

public actual val SharedRes.assets.allChapters._9_shemuel_b_15_txt: AssetResource
  get() = CommonMainAssets18._9_shemuel_b_15_txt

public actual val SharedRes.assets.allChapters._9_shemuel_b_16_txt: AssetResource
  get() = CommonMainAssets18._9_shemuel_b_16_txt

public actual val SharedRes.assets.allChapters._9_shemuel_b_17_txt: AssetResource
  get() = CommonMainAssets18._9_shemuel_b_17_txt

public actual val SharedRes.assets.allChapters._9_shemuel_b_18_txt: AssetResource
  get() = CommonMainAssets18._9_shemuel_b_18_txt

public actual val SharedRes.assets.allChapters._9_shemuel_b_19_txt: AssetResource
  get() = CommonMainAssets18._9_shemuel_b_19_txt

public actual val SharedRes.assets.allChapters._9_shemuel_b_20_txt: AssetResource
  get() = CommonMainAssets18._9_shemuel_b_20_txt

public actual val SharedRes.assets.allChapters._9_shemuel_b_21_txt: AssetResource
  get() = CommonMainAssets18._9_shemuel_b_21_txt

public actual val SharedRes.assets.allChapters._9_shemuel_b_22_txt: AssetResource
  get() = CommonMainAssets18._9_shemuel_b_22_txt

public actual val SharedRes.assets.allChapters._9_shemuel_b_23_txt: AssetResource
  get() = CommonMainAssets18._9_shemuel_b_23_txt

public actual val SharedRes.assets.allChapters._9_shemuel_b_24_txt: AssetResource
  get() = CommonMainAssets18._9_shemuel_b_24_txt

public actual val SharedRes.assets.animations.bible_search_json: AssetResource
  get() = CommonMainAssets18.bible_search_json

public actual val SharedRes.assets.fonts.Keter_Medium_ttf: AssetResource
  get() = CommonMainAssets18.Keter_Medium_ttf

public actual val SharedRes.assets.mikudLevels.READ_ME_txt: AssetResource
  get() = CommonMainAssets18.READ_ME_txt

public actual val SharedRes.assets.mikudLevels.adults.adults_international_txt: AssetResource
  get() = CommonMainAssets18.adults_international_txt

public actual val SharedRes.assets.mikudLevels.adults.adults_national_txt: AssetResource
  get() = CommonMainAssets18.adults_national_txt

public actual val SharedRes.assets.mikudLevels.adults.introduction_adults_txt: AssetResource
  get() = CommonMainAssets18.introduction_adults_txt

public actual val SharedRes.assets.mikudLevels.full_mikud_list_txt: AssetResource
  get() = CommonMainAssets18.full_mikud_list_txt

public actual val SharedRes.assets.mikudLevels.mikud_menu_txt: AssetResource
  get() = CommonMainAssets18.mikud_menu_txt

public actual val SharedRes.assets.mikudLevels.youth.introduction_youth_txt: AssetResource
  get() = CommonMainAssets18.introduction_youth_txt

public actual val SharedRes.assets.mikudLevels.youth.youth_religious_txt: AssetResource
  get() = CommonMainAssets18.youth_religious_txt

public actual val SharedRes.assets.mikudLevels.youth.youth_state_txt: AssetResource
  get() = CommonMainAssets18.youth_state_txt

public actual val SharedRes.assets.onqelos._1_bereshit_onqelos_txt: AssetResource
  get() = CommonMainAssets18._1_bereshit_onqelos_txt

public actual val SharedRes.assets.onqelos._2_shemot_onqelos_txt: AssetResource
  get() = CommonMainAssets18._2_shemot_onqelos_txt

public actual val SharedRes.assets.onqelos._3_vayikra_onqelos_txt: AssetResource
  get() = CommonMainAssets18._3_vayikra_onqelos_txt

public actual val SharedRes.assets.onqelos._4_bamidbar_onqelos_txt: AssetResource
  get() = CommonMainAssets18._4_bamidbar_onqelos_txt

public actual val SharedRes.assets.onqelos._5_devarim_onqelos_txt: AssetResource
  get() = CommonMainAssets18._5_devarim_onqelos_txt
